module.exports = __webpack_public_path__ + "3c19e615a1a7375770e481a70d0b7d0e.MP3";